export default __webpack_public_path__ + "0121bed9461baad33d97038002db90cf.svg";